<template>
  <b-container>
    <div class="exam__list">

      <h3 class="exam__list__title">Đề thi của tôi</h3>

      <b-row>
        <template v-for="exam in exams">
          <b-col :key="exam.exam_id" md="3" sm="4" xs="12">
            <div class="exam__item">
              <h4 class="exam__item__title">
                <b-link
                  :to="{
                    name: 'exam-detail',
                    params: { id: exam.exam.id, slug: exam.exam.slug }
                  }"
                  :title="exam.exam.description"
                  >{{ exam.exam.name }}</b-link
                >
              </h4>
              <div class="exam__item__time">
                <img src="@/assets/images/ic_time.png" alt="" />
                <span>{{ exam.exam.time }} phút</span>
              </div>

              <b-link
                :to="{
                  name: 'exam-detail',
                  params: { id: exam.exam.id, slug: exam.exam.slug }
                }"
                class="exam__item__btn"
                >Xem chi tiết</b-link
              >
            </div>
          </b-col>
        </template>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { STORE_KEY } from '../_store/constants'

export default {
  name: 'UserExamList',
  data() {
    return {
      //
    }
  },
  computed: {
    ...mapGetters({
      exams: `${STORE_KEY}/exams`,
      isLoadingExam: `${STORE_KEY}/isLoadingExam`
    })
  },
  beforeMount() {
    this.userExams();
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, ['userExams'])
  }
};
</script>